export const days: Array<{ label: string; value: string }> = [];
for (let i = 1; i <= 31; i++) {
  days.push({
    label: String(i),
    value: String(i),
  });
}

export const months: Array<{ label: string; value: string }> = [];
for (let i = 1; i <= 12; i++) {
  months.push({
    label: String(i),
    value: String(i),
  });
}

export const years: Array<{ label: string; value: string }> = [];
for (let i = 1923; i <= 2013; i++) {
  years.push({
    label: String(i),
    value: String(i),
  });
}
